// Enum số
// nmduc1 4/4/2023

export default {
  MaxPrintHeight: '328', // Chiều cao tối đa của dropdown in (10 chứng từ)
};
